import Component from '../../../scripts/utilities/component';

class SquadNav extends Component {
    componentDidMount() {
        this.links = [...this.root.querySelectorAll('[data-ref="link"]')];
        this.playersWrapper = this.mount.querySelector('[data-ref="squad-list"]');

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.links.forEach((link) => {
            link.addEventListener('click', this.handleClick.bind(this), true);
        });
    }

    handleClick(e) {
        e.preventDefault();

        if (e.currentTarget.classList.contains('is--active')) {
            return;
        }

        const id = e.target.href.split('#')[1];
        const allPlayerLists = [...this.playersWrapper.querySelectorAll('[data-ref="player"]')];
        const selectedGroup = [...this.playersWrapper.querySelectorAll(`[data-group="${id}"]`)];

        this.links.forEach((link) => {
            link.classList.remove('is--active');
            link.removeAttribute('aria-disabled');
            link.removeAttribute('tabindex');
        });

        e.target.classList.add('is--active');
        e.target.setAttribute('aria-disabled', 'true');
        e.target.setAttribute('tabindex', '-1');

        allPlayerLists.forEach((playerList) => {
            const list = playerList;
            list.classList.add('is--hidden');
        });

        setTimeout(() => {
            const filterableList = id === 'all' ? allPlayerLists : selectedGroup;

            filterableList.forEach((playerList) => {
                const list = playerList;
                list.classList.remove('is--hidden');
            });
        }, 150);
    }
}

export default SquadNav;



// WEBPACK FOOTER //
// ./components/eng-ms-squad-nav/scripts/squad-nav.js